import { useEffect, useMemo } from "react"

import { TranslationsService } from "./service"
import { TranslationsContext } from "./types"

type Props = Pick<TranslationsService, "getDefaultLanguage"> & Pick<TranslationsContext, "changeLanguage">

export const useDefaultLanguageEffect = ({ getDefaultLanguage, changeLanguage }: Props) => {
  const defaultLanguage = useMemo(() => getDefaultLanguage(), [getDefaultLanguage])

  useEffect(() => {
    !!defaultLanguage && changeLanguage(defaultLanguage)
  }, [defaultLanguage])
}
